/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable prefer-destructuring */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-array-index-key */
import React, { useState, useCallback, useRef } from 'react';
import {
  Button, Checkbox, FormControlLabel, Chip, LinearProgress, Tooltip,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PreviewIcon from '@mui/icons-material/Preview';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReplayIcon from '@mui/icons-material/Replay';
import BatchPredictionIcon from '@mui/icons-material/BatchPrediction';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import type { RootState } from 'mainStore';
import { formatTenantName } from 'utils/formatTenantName';
import type {
  IBulkImportResponse, IBulkStatusResponse, IBulkImportError, ICreatedLease, IBulkLease,
  IBatchProcessResponse,
} from './types';
import './_BulkIngestion.scss';

export default function BulkIngestionContent(): JSX.Element {
  const currentWorkspace = useSelector(
    (state: RootState) => state.workspaces.currentWorkspace.currentWorkspace,
  );
  const { enqueueSnackbar } = useSnackbar();

  const [file, setFile] = useState<File | null>(null);
  const [skipS3Check, setSkipS3Check] = useState(false);
  const [triggerProcessing, setTriggerProcessing] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [importResult, setImportResult] = useState<IBulkImportResponse['detail'] | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // ── Bulk import status polling ──
  const [isPolling, setIsPolling] = useState(false);
  const {
    data: statusData,
    refetch: refetchStatus,
    isLoading: statusLoading,
  } = useQuery(
    ['bulk-import-status', currentWorkspace?.id],
    async () => {
      const res = await axios.get<IBulkStatusResponse>(
        `api/lease/bulk-import/status/?workspace=${currentWorkspace.id}`,
      );
      const detail = res.data.detail;
      setIsPolling(detail.processing > 0);
      return detail;
    },
    {
      enabled: Boolean(currentWorkspace?.id),
      refetchInterval: isPolling ? 10000 : false,
    },
  );

  // ── Upload mutation (dry-run or actual) ──
  const uploadMutation = useMutation(
    async ({ dryRun }: { dryRun: boolean }) => {
      if (!file || !currentWorkspace?.id) throw new Error('No file or workspace');
      const formData = new FormData();
      formData.append('manifest', file);
      const params = new URLSearchParams();
      params.set('workspace', String(currentWorkspace.id));
      if (dryRun) params.set('dry_run', 'true');
      if (skipS3Check) params.set('skip_s3_check', 'true');
      if (triggerProcessing && !dryRun) params.set('process', 'true');

      const res = await axios.post<IBulkImportResponse>(
        `api/lease/bulk-import/?${params.toString()}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      return res.data.detail;
    },
    {
      onSuccess: (data) => {
        setImportResult(data);
        if (data.dry_run) {
          enqueueSnackbar(data.message, { variant: 'info' });
        } else {
          enqueueSnackbar(data.message, { variant: 'success' });
          refetchStatus();
        }
      },
      onError: (err: any) => {
        const msg = err?.response?.data?.detail?.message || err?.message || 'Upload failed';
        enqueueSnackbar(msg, { variant: 'error' });
        if (err?.response?.data?.detail) {
          setImportResult(err.response.data.detail);
        }
      },
    },
  );

  // ── Batch processing mutation ──
  const batchMutation = useMutation(
    async ({ limit }: { limit: number }) => {
      if (!currentWorkspace?.id) throw new Error('No workspace');
      const params = new URLSearchParams();
      params.set('workspace', String(currentWorkspace.id));
      params.set('limit', String(limit));
      const res = await axios.post<IBatchProcessResponse>(
        `api/lease/batch-process/?${params.toString()}`,
      );
      return res.data.detail;
    },
    {
      onSuccess: (data) => {
        enqueueSnackbar(
          `${data.message}${data.estimated_minutes ? ` (~${data.estimated_minutes} min)` : ''}`,
          { variant: 'success' },
        );
        setIsPolling(true);
        refetchStatus();
      },
      onError: (err: any) => {
        const msg = err?.response?.data?.detail?.message || err?.message || 'Batch process failed';
        enqueueSnackbar(msg, { variant: 'error' });
      },
    },
  );

  // ── Retry failed mutation ──
  const retryMutation = useMutation(
    async () => {
      if (!currentWorkspace?.id) throw new Error('No workspace');
      const params = new URLSearchParams();
      params.set('workspace', String(currentWorkspace.id));
      const res = await axios.post<IBatchProcessResponse>(
        `api/lease/batch-process/retry/?${params.toString()}`,
      );
      return res.data.detail;
    },
    {
      onSuccess: (data) => {
        enqueueSnackbar(data.message, { variant: 'success' });
        setIsPolling(true);
        refetchStatus();
      },
      onError: (err: any) => {
        const msg = err?.response?.data?.detail?.message || err?.message || 'Retry failed';
        enqueueSnackbar(msg, { variant: 'error' });
      },
    },
  );

  const isBatchBusy = batchMutation.isLoading || retryMutation.isLoading;

  // ── Drag & drop ──
  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setDragging(true);
  }, []);
  const handleDragLeave = useCallback(() => { setDragging(false); }, []);
  const handleDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setDragging(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped && dropped.name.endsWith('.csv')) {
      setFile(dropped);
      setImportResult(null);
    } else {
      enqueueSnackbar('Please upload a CSV file', { variant: 'warning' });
    }
  }, [enqueueSnackbar]);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selected = e.target.files?.[0];
    if (selected) {
      setFile(selected);
      setImportResult(null);
    }
  };

  const handleDryRun = (): void => { uploadMutation.mutate({ dryRun: true }); };
  const handleImport = (): void => { uploadMutation.mutate({ dryRun: false }); };

  const getProgressPercent = (): number => {
    if (!statusData || statusData.total === 0) return 0;
    return Math.round(((statusData.processed + statusData.failed) / statusData.total) * 100);
  };

  const getStatusChip = (lease: IBulkLease): JSX.Element => {
    if (lease.progress === -1) return <span className='chip failed'>Failed</span>;
    if (lease.is_processed && lease.progress === 100) return <span className='chip processed'>Processed</span>;
    if (lease.progress > 0) return <span className='chip processing'>Processing</span>;
    return <span className='chip pending'>Pending</span>;
  };

  return (
    <div className='bulk-ingestion-wrapper'>
      {/* Header */}
      <div className='page-header'>
        <h1>Bulk Lease Ingestion</h1>
        {statusData && statusData.total > 0 && (
          <Tooltip title='Refresh status'>
            <Button
              variant='outlined'
              size='small'
              startIcon={<RefreshIcon />}
              onClick={() => { refetchStatus(); }}
              disabled={statusLoading}
            >
              Refresh
            </Button>
          </Tooltip>
        )}
      </div>

      {/* Status cards from existing imports */}
      {statusData && statusData.total > 0 && (
        <>
          <div className='summary-cards'>
            <div className='summary-card'>
              <div className='card-value blue'>{statusData.total}</div>
              <div className='card-label'>Total Imported</div>
            </div>
            <div className='summary-card'>
              <div className='card-value green'>{statusData.processed}</div>
              <div className='card-label'>Processed</div>
            </div>
            <div className='summary-card'>
              <div className='card-value orange'>{statusData.processing}</div>
              <div className='card-label'>Processing</div>
            </div>
            <div className='summary-card'>
              <div className='card-value purple'>{statusData.pending}</div>
              <div className='card-label'>Pending</div>
            </div>
            <div className='summary-card'>
              <div className='card-value red'>{statusData.failed}</div>
              <div className='card-label'>Failed</div>
            </div>
          </div>

          {/* Overall progress bar */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, fontSize: 13 }}>
              <span>Overall Progress</span>
              <span>
                {statusData.processed + statusData.failed}
                {' / '}
                {statusData.total}
                {' '}
                (
                {getProgressPercent()}
                %)
              </span>
            </div>
            <LinearProgress
              variant='determinate'
              value={getProgressPercent()}
              sx={{ height: 8, borderRadius: 4 }}
            />
          </div>
        </>
      )}

      {/* ── Batch Processing Controls ── */}
      {statusData && statusData.pending > 0 && (
        <div className='batch-controls'>
          <div className='batch-header'>
            <BatchPredictionIcon sx={{ fontSize: 20, mr: 1, color: '#1565c0' }} />
            <h3>Batch Processing (Textract + GPT)</h3>
            <span className='batch-pending'>
              {statusData.pending}
              {' pending'}
            </span>
          </div>
          <div className='batch-subtitle'>
            Process uploaded leases through Textract OCR → GPT extraction. Start small and verify before processing all.
          </div>
          <div className='batch-buttons'>
            <Tooltip title='Process 10 leases to verify quality'>
              <Button
                variant='outlined'
                size='small'
                startIcon={<PlayArrowIcon />}
                onClick={() => { batchMutation.mutate({ limit: 10 }); }}
                disabled={isBatchBusy}
                sx={{ textTransform: 'none' }}
              >
                Process 10
              </Button>
            </Tooltip>
            <Tooltip title='Process 50 leases'>
              <Button
                variant='outlined'
                size='small'
                startIcon={<PlayArrowIcon />}
                onClick={() => { batchMutation.mutate({ limit: 50 }); }}
                disabled={isBatchBusy}
                sx={{ textTransform: 'none' }}
              >
                Process 50
              </Button>
            </Tooltip>
            <Tooltip title={`Process all ${statusData.pending} pending leases`}>
              <Button
                variant='contained'
                size='small'
                startIcon={<PlayArrowIcon />}
                onClick={() => { batchMutation.mutate({ limit: statusData.pending }); }}
                disabled={isBatchBusy}
                color='primary'
                sx={{ textTransform: 'none' }}
              >
                Process All (
                {statusData.pending}
                )
              </Button>
            </Tooltip>
          </div>
          {isBatchBusy && <LinearProgress sx={{ mt: 1, borderRadius: 4 }} />}
        </div>
      )}

      {/* ── Retry Failed Controls ── */}
      {statusData && statusData.failed > 0 && (
        <div className='batch-controls retry'>
          <div className='batch-header'>
            <ReplayIcon sx={{ fontSize: 20, mr: 1, color: '#d32f2f' }} />
            <h3>
              Retry Failed (
              {statusData.failed}
              )
            </h3>
          </div>
          <div className='batch-buttons'>
            <Button
              variant='outlined'
              size='small'
              color='error'
              startIcon={<ReplayIcon />}
              onClick={() => { retryMutation.mutate(); }}
              disabled={isBatchBusy}
              sx={{ textTransform: 'none' }}
            >
              Retry All Failed
            </Button>
          </div>
        </div>
      )}

      {/* Upload section */}
      <div
        className={`upload-section ${dragging ? 'dragging' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <CloudUploadIcon className='upload-icon' />
        <div className='upload-title'>
          {file ? file.name : 'Upload Manifest CSV'}
        </div>
        <div className='upload-subtitle'>
          {file
            ? `${(file.size / 1024).toFixed(1)} KB — Drop a new file to replace`
            : 'Drag & drop your manifest.csv here, or click to browse'}
        </div>
        <input
          ref={fileInputRef}
          type='file'
          accept='.csv'
          style={{ display: 'none' }}
          onChange={handleFileSelect}
        />
        <Button
          variant='outlined'
          onClick={() => fileInputRef.current?.click()}
          sx={{ textTransform: 'none' }}
        >
          Browse Files
        </Button>
      </div>

      {/* Options */}
      <div className='options-row'>
        <FormControlLabel
          control={(
            <Checkbox
              checked={skipS3Check}
              onChange={(e) => { setSkipS3Check(e.target.checked); }}
              size='small'
            />
          )}
          label='Skip S3 verification (faster)'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={triggerProcessing}
              onChange={(e) => { setTriggerProcessing(e.target.checked); }}
              size='small'
            />
          )}
          label='Auto-process after import (Textract + GPT)'
        />

        <div style={{ flex: 1 }} />

        <Button
          variant='outlined'
          startIcon={<PreviewIcon />}
          onClick={handleDryRun}
          disabled={!file || uploadMutation.isLoading}
          sx={{ textTransform: 'none', mr: 1 }}
        >
          Dry Run
        </Button>
        <Button
          variant='contained'
          startIcon={<PlayArrowIcon />}
          onClick={handleImport}
          disabled={!file || uploadMutation.isLoading}
          sx={{ textTransform: 'none' }}
          color='primary'
        >
          Import
        </Button>
      </div>

      {uploadMutation.isLoading && <LinearProgress sx={{ mb: 2 }} />}

      {/* Dry run / import results */}
      {importResult && (
        <>
          {/* Result summary */}
          <div className='summary-cards'>
            <div className='summary-card'>
              <div className='card-value blue'>{importResult.summary.total_rows}</div>
              <div className='card-label'>Total Rows</div>
            </div>
            <div className='summary-card'>
              <div className='card-value green'>{importResult.summary.valid_rows}</div>
              <div className='card-label'>Valid Rows</div>
            </div>
            <div className='summary-card'>
              <div className='card-value blue'>{importResult.summary.buildings_count}</div>
              <div className='card-label'>Buildings</div>
            </div>
            <div className='summary-card'>
              <div className='card-value blue'>{importResult.summary.tenants_count}</div>
              <div className='card-label'>Tenants</div>
            </div>
            <div className='summary-card'>
              <div className='card-value orange'>{importResult.summary.s3_missing}</div>
              <div className='card-label'>S3 Missing</div>
            </div>
            <div className='summary-card'>
              <div className='card-value red'>{(importResult.errors || []).length}</div>
              <div className='card-label'>Errors</div>
            </div>
          </div>

          {/* Asset type chips */}
          <div style={{ marginBottom: 16 }}>
            {importResult.summary.asset_types.map((at) => (
              <Chip key={at} label={at} size='small' sx={{ mr: 1 }} />
            ))}
          </div>

          {/* Message */}
          <div className='results-section'>
            <div className='results-header'>
              <h3>
                {importResult.dry_run ? '🔍 Dry Run Result' : '✅ Import Result'}
              </h3>
              {!importResult.dry_run && importResult.created !== undefined && (
                <span style={{ fontSize: 13, color: 'rgba(33,33,33,0.6)' }}>
                  {importResult.created}
                  {' created, '}
                  {importResult.skipped}
                  {' skipped, '}
                  {importResult.failed}
                  {' failed'}
                </span>
              )}
            </div>
            <div style={{ padding: '12px 20px', fontSize: 14 }}>
              {importResult.message}
            </div>
          </div>

          {/* Errors table */}
          {importResult.errors && importResult.errors.length > 0 && (
            <div className='results-section'>
              <div className='results-header'>
                <h3>
                  ⚠️ Errors (
                  {importResult.errors.length}
                  )
                </h3>
              </div>
              <div className='results-body'>
                {importResult.errors.map((err: IBulkImportError, idx: number) => (
                  <div className='error-row' key={`err-${idx}`}>
                    <span className='error-row-num'>
                      Row
                      {' '}
                      {err.row}
                    </span>
                    <span className='error-row-msg'>{err.error}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Created leases table */}
          {importResult.created_leases && importResult.created_leases.length > 0 && (
            <div className='results-section'>
              <div className='results-header'>
                <h3>
                  Created Leases (
                  {importResult.created_leases.length}
                  )
                </h3>
              </div>
              <div className='results-body'>
                <div className='lease-row header'>
                  <span>ID</span>
                  <span>Tenant</span>
                  <span>File</span>
                  <span>S3 Key</span>
                </div>
                {importResult.created_leases.map((lease: ICreatedLease) => (
                  <div className='lease-row' key={lease.lease_id}>
                    <span>{lease.lease_id}</span>
                    <span>{lease.tenant}</span>
                    <span>{lease.file_name}</span>
                    <Tooltip title={lease.s3_key}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {lease.s3_key}
                      </span>
                    </Tooltip>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      {/* Existing bulk leases status table */}
      {statusData && statusData.leases.length > 0 && (
        <div className='results-section'>
          <div className='results-header'>
            <h3>
              Imported Leases (
              {statusData.leases.length}
              )
            </h3>
          </div>
          <div className='results-body'>
            <table className='status-table'>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Tenant</th>
                  <th>Asset Type</th>
                  <th>Building</th>
                  <th>Status</th>
                  <th>Progress</th>
                </tr>
              </thead>
              <tbody>
                {statusData.leases.map((lease: IBulkLease) => (
                  <tr key={lease.id}>
                    <td>{lease.id}</td>
                    <td>{formatTenantName(lease.tenant_name)}</td>
                    <td>{lease.meta?.asset_type || '—'}</td>
                    <td>{lease.meta?.building || '—'}</td>
                    <td>{getStatusChip(lease)}</td>
                    <td>
                      {lease.progress >= 0 ? (
                        <div className='progress-bar-container'>
                          <div
                            className={`progress-bar-fill ${lease.progress === 100 ? 'green' : 'blue'}`}
                            style={{ width: `${lease.progress}%` }}
                          />
                        </div>
                      ) : (
                        <span style={{ color: '#d32f2f', fontSize: 12 }}>{lease.message}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Empty state */}
      {!importResult && (!statusData || statusData.total === 0) && !file && (
        <div className='empty-state'>
          <p>No bulk imports yet. Upload a manifest.csv to get started.</p>
          <p style={{ fontSize: 12, marginTop: 8 }}>
            Generate the manifest with:
            {' '}
            <code>python docs/extract_leases.py --source ./Property --upload</code>
          </p>
        </div>
      )}
    </div>
  );
}
